import gql from 'graphql-tag';

const Subscription = {
  productSubscribe: gql`
    mutation productSubscribe(
      $subscription_type: String
      $phone: String
      $email: String
      $productId: Float!
    ) {
      productSubscribe(
        subscription_type: $subscription_type
        phone: $phone
        email: $email
        productId: $productId
      ) {
        result
        error
      }
    }
  `,
  checkPeopleSubscription: gql`
    query checkPeopleSubscription(
      $productId: Float!
      $subscription_type: String
    ) {
      checkPeopleSubscription(
        productId: $productId
        subscription_type: $subscription_type
      ) {
        peopleSubscription {
          existing {
            # указывает на наличие подписки по типам
            subscribed # == true, if (email && sms) !== null
            sms
            email
          }
        }
      }
    }
  `,
  confirmSubscribe: gql`
    query confirmSubscribe($hash: String, $peopleId: Int) {
      confirmSubscribe(hash: $hash, peopleId: $peopleId) {
        result
        message
        promocode
        email
      }
    }
  `
};

export default Subscription;
